import apiFetch from '../apiFetch'
export default function (dossierSubTypeId, organizedUnitId, token) {
  return apiFetch({ endPoint: `entity/defaultEntity?dossierSubTypeId=${dossierSubTypeId}&organizedUnitId=${organizedUnitId}`, method: 'GET', body: null, token: token })
}
